import dynamic from 'next/dynamic'

import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import { SizeGuideV2 as SizeGuideV2Legacy } from './SizeGuideV2-legacy'

import type { SizeGuideProps } from '../sizeGuide/SizeGuide'

const SizeGuideV2DS = dynamic(() =>
  import(/* webpackChunkName: "size-guide-v2-ds" */ '@src/components/blocks/size-guide-v2-ds').then(m => ({
    default: m.SizeGuideV2DS,
  })),
)

export const SizeGuideV2 = (props: SizeGuideProps) => {
  if (shouldUseDesignSystem()) {
    return <SizeGuideV2DS {...props} />
  }
  return <SizeGuideV2Legacy {...props} />
}
